import React, { createContext, useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import { getVoicePreferences, saveVoicePreferences } from "../services/voicePreferencesService";

const VoicePreferencesContext = createContext(null);

VoicePreferencesProvider.propTypes = {
  children: PropTypes.node,
};

export function VoicePreferencesProvider({ children }) {
  const [pollyMapping, setPollyMapping] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null); // null | "not_set" | "network_error"

  const fetchPreferences = useCallback(async (userEmail) => {
    if (!userEmail) return;
    setIsLoading(true);
    setError(null);
    try {
      const mapping = await getVoicePreferences(userEmail);
      setPollyMapping(mapping);
      if (!mapping || mapping.length === 0) {
        setError("not_set");
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[VoicePreferencesContext] fetchPreferences failed:", err.message);
      setPollyMapping([]);
      setError("network_error");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const savePreferences = useCallback(async (userEmail, mapping) => {
    await saveVoicePreferences(userEmail, mapping);
    // Update local context so the saved data is immediately available
    setPollyMapping(mapping);
    setError(null);
  }, []);

  return (
    <VoicePreferencesContext.Provider
      value={{
        pollyMapping,
        isLoading,
        error,
        fetchPreferences,
        savePreferences,
      }}
    >
      {children}
    </VoicePreferencesContext.Provider>
  );
}

export function useVoicePreferences() {
  const ctx = useContext(VoicePreferencesContext);
  if (!ctx) {
    throw new Error("useVoicePreferences must be used inside <VoicePreferencesProvider>");
  }
  return ctx;
}
